import withHandler from 'recompose/withHandlers';
import compose from 'recompose/compose';
import BreadCrumbItem from './BreadCrumbItem';
import { trackBreadcrumbClick } from '../../../../analytics/category/product.js';
import withTextOverlay from './withTextOverlay';

const enhance = compose(
  withTextOverlay,
  withHandler({
    onClick: props => () => {
      props.setActivePage(props.pageNumber);
      trackBreadcrumbClick(props.label);
    },
  }),
);

export default enhance(BreadCrumbItem);



// WEBPACK FOOTER //
// ./src/client/js/view/components/BreadCrumb/BreadCrumbItem/index.js